module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "hidden-md-and-down"
  }, [(this.rowData.organisation) ? _c('el-col', {
    attrs: {
      "span": this.isManager() ? 18 : 24
    }
  }, [_c('contacts-popover', {
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.isSuper()),
      expression: "this.isSuper()"
    }],
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSuper()),
      expression: "isSuper()"
    }],
    attrs: {
      "icon": "fa fa-trash-alt",
      "size": "small",
      "type": "danger",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-080a9ac0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressControls.vue
// module id = 1309
// module chunks = 0